<template>
  <div
    class="pano"
    :class="{
      loading: Loading,
    }"
  >
    <img src="@/assets/Images/Global/Loader.svg" alt="" class="pano__loader" />
    <iframe
      @load="Loading = false"
      src="https://3drender.es/Trabajos/doccia/"
      frameborder="0"
      class="pano__content"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "Pano",
  data() {
    return {
      Loading: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.pano {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-transition: height 0.35s ease-in-out;
  -moz-transition: height 0.35s ease-in-out;
  -ms-transition: height 0.35s ease-in-out;
  -o-transition: height 0.35s ease-in-out;
  transition: height 0.35s ease-in-out;
  &__loader {
    opacity: 0;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    height: 125px;
    -webkit-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
  }
  &__content {
    opacity: 1;
    width: 100%;
    height: 100%;
    -webkit-transition: opacity 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out;
  }
  &.loading {
    & .pano {
      &__loader {
        opacity: 1;
        -webkit-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      }
      &__content {
        opacity: 0;
        pointer-events: none;
        -webkit-transition: opacity 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out;
      }
    }
  }
  @media screen and (max-width: 950px) and (min-height: 600px) {
    height: calc(100% - 60px);
    -webkit-transition: height 0.35s ease-in-out;
    -moz-transition: height 0.35s ease-in-out;
    -ms-transition: height 0.35s ease-in-out;
    -o-transition: height 0.35s ease-in-out;
    transition: height 0.35s ease-in-out;
  }
}
</style>
